
import { useCallback } from 'react';
import { CRMUser } from '@/types/crm';
import { EmailHistoryUpdate } from './types';

export const useEmailTracking = (
  users: CRMUser[],
  setUsers: (users: CRMUser[]) => void,
  selectedUser: CRMUser | null,
  setSelectedUser: (user: CRMUser | null) => void
) => {
  const updateEmailStatus = useCallback(
    ({ userId, emailId }: EmailHistoryUpdate, status: 'delivered' | 'opened') => {
      const statusDate = new Date().toISOString();
      const statusKey = status === 'delivered' ? 'deliveredDate' : 'openedDate';
      
      const updatedUsers = users.map(user => {
        if (user.id === userId) {
          return {
            ...user,
            referralHistory: user.referralHistory.map(email => {
              if (email.id === emailId) {
                return {
                  ...email,
                  [statusKey]: statusDate,
                  status: status
                };
              }
              return email;
            })
          };
        }
        return user;
      });
      
      setUsers(updatedUsers);
      
      // Update selected user if needed
      if (selectedUser && selectedUser.id === userId) {
        const updatedUser = updatedUsers.find(u => u.id === userId);
        if (updatedUser) {
          setSelectedUser(updatedUser);
        }
      }
    },
    [users, setUsers, selectedUser, setSelectedUser]
  );

  const markEmailAsDelivered = useCallback(
    (userId: string, emailId: string) => {
      updateEmailStatus({ userId, emailId }, 'delivered');
    },
    [updateEmailStatus]
  );

  const markEmailAsOpened = useCallback(
    (userId: string, emailId: string) => {
      updateEmailStatus({ userId, emailId }, 'opened');
    },
    [updateEmailStatus]
  );

  return {
    markEmailAsDelivered,
    markEmailAsOpened
  };
};
